import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {getSuggestedFailure, getSuggestedSuccess} from "features/components/suggested/reducer";

export function* getSuggestedSaga({payload}) {
    const {type, id} = payload;
    try {
        const apis = {"video" : api.suggestedVideo, "directory": api.suggestedDirectory, "event": api.suggestedEvent, "thread": api.suggestedThreadsApi};
        const apiToCall = apis[type];
        const data = yield call([api, apiToCall], id);
        yield put(getSuggestedSuccess({type, data}));
    } catch (e) {
        yield put(getSuggestedFailure(getErrorFromMessage(e)));
    }

}